<template>
    <div class="container">
        <div v-if="loadingDone">
            <div v-if="selectedSet !== null" class="row">
                <div class="col-12">
                    <h1 class="page-heading text-center text-dark gallery-heading">
                        <img :src="selectedSet.json.images.logo" alt="" class="set-display-logo"><br/>
                        <br/>
                        {{ selectedSet.json.name }}
                        <img v-if="selectedSet.set_id !== 'base1'" :src="selectedSet.json.images.symbol" alt="" class="set-display-symbol"><br/>
                        <small style="font-size: 0.5em;">
                            <span class="badge-pill bg-primary text-secondary px-2 py-1 mx-1" v-text="selectedSet.release_date"></span>
                            <span class="badge-pill bg-primary text-secondary px-2 py-1 mx-1">{{ selectedSet.json.printedTotal }} {{ $t('gallery.cards') }} {{ setSecrets > 0 ? ('+ '+setSecrets+' '+$t('gallery.secrets')) : '' }}</span>
                            <span class="badge-pill bg-primary text-secondary px-2 py-1 mx-1" v-text="selectedSet.set_series"></span>
                            <span class="badge-pill bg-primary text-secondary px-2 py-1 mx-1" v-text="getSetType()"></span>
                            <span class="badge-pill bg-primary text-secondary px-2 py-1 mx-1">
                                <img :src="getSetLanguageIcon()" class="language-icon" alt="">
                            </span>
                        </small>

                        <span class="set-description text-start mt-3" v-if="selectedSet.description" v-html="selectedSet.description.replace('\n', '<br/>')"></span>
                    </h1>
                </div>

                <div class="col-12">
                    <router-link :to="{name: 'gallery-list'}" class="btn btn-success"><i class="fa-solid fa-arrow-left"></i> {{ $t('gallery.back') }}</router-link>
                </div>

                <div class="col-12">
                    <input type="search" class="form-control w-80" v-model="searchQuery" :placeholder="$t('gallery.search')">

                    <div class="mt-1 form-group form-check form-switch">
                        <input type="checkbox" class="form-check-input" v-model="highlightOwned" id="highlightOwned">
                        <label class="form-check-label" for="highlightOwned">{{ $t('gallery.highlight') }}</label>
                    </div>
                </div>

                <div class="col-12 row px-0 py-0">
                    <div class="col">
                        <a href="javascript:" :class="'btn btn-sm w-100'+(bigFilter === 'pokemon' ? ' btn-secondary' : ' btn-dark')" v-on:click="bigFilter = bigFilter === 'pokemon' ? null : 'pokemon'">{{ $t('gallery.types.pokemon') }}</a>
                    </div>
                    <div class="col">
                        <a href="javascript:" :class="'btn btn-sm w-100'+(bigFilter === 'trainer' ? ' btn-secondary' : ' btn-dark')" v-on:click="bigFilter = bigFilter === 'trainer' ? null : 'trainer'">{{ $t('gallery.types.trainer') }}</a>
                    </div>
                    <div class="col">
                        <a href="javascript:" :class="'btn btn-sm w-100'+(bigFilter === 'energy' ? ' btn-secondary' : ' btn-dark')" v-on:click="bigFilter = bigFilter === 'energy' ? null : 'energy'">{{ $t('gallery.types.energy') }}</a>
                    </div>
                    <div class="col">
                        <a href="javascript:" :class="'btn btn-sm w-100'+(bigFilter === 'illustration' ? ' btn-secondary' : ' btn-dark')" v-on:click="bigFilter = bigFilter === 'illustration' ? null : 'illustration'">{{ $t('gallery.types.illustration') }}</a>
                    </div>
                </div>

                <div class="col-12 p-0" id="card-collection" style="display: flex; flex-direction: column-reverse;">
                    <div class="row p-0">
                        <div v-for="card in filteredCardGallery"
                             class="col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 text-center collection-card">
                            <a href="javascript:" class="text-left mb-2" v-on:click="cardClick(card)">
                                <img loading="lazy" :src="getSmallCardImageUrl(card)" style="width: auto; max-width: 100%;" :class="'card-thumbnail '+(card.is_in_set_collection || highlightOwned === false ? 'card-in-collection' : 'card-missing-in-collection')" alt="card">
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-12 p-0" id="set-items" v-if="setItems.length > 0">
                    <template v-if="setItems.filter(i => i.item_type === 'single-booster').length > 0">
                        <h5 class="ms-2 mb-4">{{ $t('gallery.boosters') }}</h5>

                        <div class="row p-0">
                            <template v-for="item in setItems.filter(i => i.item_type === 'single-booster')">
                                <div v-for="packshot in item.asset_url.split(';')" class="col-3 text-center">
                                    <a v-if="item.item_type === 'single-booster'" data-lightbox="boosters" :href="'/'+packshot">
                                        <img :src="'/'+packshot" alt="" class="w-100"><br/>
                                    </a>
                                </div>
                            </template>
                        </div>
                    </template>

                    <template v-if="setItems.filter(i => i.item_type !== 'single-booster').length > 0">
                        <h5 class="ms-2 mb-4">{{ $t('gallery.products') }}</h5>

                        <div class="row p-0">
                            <div v-for="item in setItems.filter(i => i.item_type !== 'single-booster')" class="col-6 col-sm-4 col-md-3 col-lg-2 text-center">
                                <a data-lightbox="products" :href="(item.asset_url.startsWith('/') ? '' : '/')+item.asset_url" :data-title="item.name">
                                    <img :src="(item.asset_url.startsWith('/') ? '' : '/')+item.asset_url" alt="" style="max-height: 15em; max-width: 100%"><br/>
                                    <div class="mt-3">{{ item.name }}</div>
                                </a>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="col-12">
                    <router-link :to="{name: 'gallery-list'}" class="btn btn-success"><i class="fa-solid fa-arrow-left"></i> {{ $t('gallery.back') }}</router-link>
                </div>
            </div>
        </div>
        <card-detail-view-canvas :card="activeCard" :gallery="true"/>
    </div>
</template>


<script>
import axios from "axios";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import CardService from "../../CardService.js";

export default {
    name: "Gallery",
    components: {CardDetailViewCanvas},
    data() {
        return {
            loadingDone: false,
            searchQuery: '',
            activeCard: null,
            selectedSet: null,
            cardGallery: [],
            highlightOwned: false,
            bigFilter: null,
            illustrationFilterRarities: [
                'Rare V',
                'Rare Prism Star',
                'Rare Prime',
                'Double Rare',
                'Rare Holo V',
                'Rare Holo VMAX',
                'Rare Holo Star',
                'Rare Holo VSTAR',
                'Rare Holo EX',
                'Rare Holo GX',
                'Rare Holo LV.X',
                'Hyper Rare',
                'Ultra Rare',
                'Rare Ultra',
                'Amazing Rare',
                'Rare Rainbow',
                'Rare BREAK',
                'Radiant Rare',
                'Radiant Super Rare',
                'Rare Shiny',
                'Shiny Rare',
                'Rare Shiny GX',
                'Rare Shining',
                'Shiny Ultra Rare',
                'ACE SPEC Rare',
                'Rare ACE',
                'Rare Secret',
                'Illustration Rare',
                'Special Illustration Rare',
                'Trainer Gallery Rare Holo',
                'LEGEND',
                'Black and White Rare',
            ],
            setItems: []
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchSet();
    },
    computed: {
        filteredCardGallery() {
            return this.selectedSet.setCards?.filter(card => {
                return (
                    card.name.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0
                    || (card.evolvesFrom && card.evolvesFrom.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0)
                    || (card.set && card.set.name.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0)
                    || (card.id.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0)
                ) && (
                    (!this.bigFilter || (this.bigFilter === 'trainer' && card.supertype === 'Trainer'))
                    || (!this.bigFilter || (this.bigFilter === 'pokemon' && card.supertype === 'Pokémon'))
                    || (!this.bigFilter || (this.bigFilter === 'energy' && card.supertype === 'Energy'))
                    || (!this.bigFilter || (this.bigFilter === 'illustration' && this.illustrationFilterRarities.includes(card.rarity)))
                )
            });
        },
        filteredCardGalleryCount() {
            let count = 0;
            this.filteredCardGallery.map(c => c.amount).forEach(s => count += Number((s ?? 1)));
            return count;
        },
        setSecrets() {
            return (this.selectedSet?.json?.total - this.selectedSet?.json?.printedTotal) ?? 0
        }
    },
    methods: {
        fetchSet() {
            axios.get('/api/gallery/' + this.$route.params.set_id).then(response => {
                this.selectedSet = response.data;
                this.selectedSet.json = JSON.parse(this.selectedSet.json);
                this.selectedSet.setCards = this.selectedSet.setCards.map(c => {
                    let cardJson = JSON.parse(c.json)
                    cardJson.is_in_set_collection = c.is_in_set_collection;
                    return cardJson;
                }).sort((a, b) => {
                    return a.id.split('-')[1].replace(/[^0-9]/g, "") - b.id.split('-')[1].replace(/[^0-9]/g, "")
                });
                this.activeCard = this.selectedSet.setCards[0];

                this.loadingDone = true;
                window.scrollTo(0, 0);
            });

            axios.get('/api/shop/items/' + this.$route.params.set_id).then(response => {
                this.setItems = response.data;

            })
        },
        cardMeetsCriteria() {
            if (this.searchQuery.trim().length > 0) {
                return this.$store.state.collection.cards.filter(card => {
                    return card.name.search(this.searchQuery) >= 0;
                })
            }

            return true;
        },
        cardClick(card) {
            this.activeCard = card;
            this.$forceUpdate;
            $("#card-detail-view-canvas").offcanvas('toggle');
        },
        sortSeriesListByName(arr) {
            const order = [
                'Base', 'Gym', 'Neo', 'E-Card', 'EX', 'Diamond & Pearl', 'Platinum', 'HeartGold & SoulSilver', 'Black & White', 'XY', 'Sun & Moon', 'Sword & Shield', 'Scarlet & Violet',
            ];

            return arr.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
        },
        getSmallCardImageUrl(card) {
            return CardService.getSmallCardImageUrl(card);
        },
        getSetType() {
            if (this.selectedSet.is_main) {
                return 'Main Series Set';
            }

            if (this.selectedSet.is_promo) {
                return 'Promo Set';
            }
        },
        getSetLanguageIcon() {
            return '/assets/dipocaco/icons/'+this.selectedSet.language+'.png';
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    border-radius: 6px;
}

.row div {
    border: none;
    margin-bottom: 1em;
}

a {
    text-decoration: none;
}

.form-control {
    max-width: 100%;
}

.collection-card {
    margin-bottom: 1em !important;
}

.card-markers {
    font-size: 1.5em;
    font-weight: bold;
    margin-top: -1em;
    display: flex;
    position: absolute;
}

.set-logo {
    max-height: 4em;
    max-width: 100%;
}

.set-icon {
    max-height: 1.8em;
}

.list-group-item {
    vertical-align: middle;
    height: 5em;
}

.series-name-heading {
    margin-bottom: 1em;
}

.page-content {
    padding-bottom: 5em;
}

.set-display-logo {
    max-height: 6em;
    max-width: 80%;
}

.set-display-symbol {
    max-height: 1em;
    margin-left: 5px;
}

.card-in-collection {
    filter: drop-shadow(1px 1px rgba(0, 0, 0, 0.2));
}

.card-missing-in-collection {
    filter: grayscale(1);
}

#set-items {
    img {
        border-radius: 0 !important;
    }
}

.badge-pill {
    font-size: .75em;
    display: inline-block;
}

.language-icon {
    max-height: 1em;
}

.set-description {
    font-size: .4em;
    padding: 0.5em;
    display: block;
}
</style>
